export function warn(msg) {
  console.error(`[vue-reactive-provide]: ${msg}`)
}
